import DeviceDetector from '../helper/DeviceDetector';

class GlobalStore {
    constructor() {
        this.state = {
            device: DeviceDetector.getDeviceType(),
            lang: document.documentElement.lang,
        };
    }

    set(key, value) {
        this.state[key] = value;
    }

    get(key) {
        return this.state[key];
    }
}

export default new GlobalStore();
